var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationPinNoFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 17,
    viewBox: "0 0 11 17",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.50013 0C2.46724 0 0 2.46728 0 5.50013C0 8.40455 4.95184 15.6811 5.16248 15.9898C5.23911 16.1009 5.36494 16.1685 5.5 16.1685C5.63506 16.1685 5.76186 16.1018 5.83752 15.9898C6.04825 15.6811 11 8.40526 11 5.50013C11 2.46724 8.53272 0 5.49987 0H5.50013ZM5.4993 15.0235C3.9327 12.66 0.819129 7.5419 0.819129 5.50013C0.819129 2.91846 2.91923 0.818192 5.50106 0.818192C8.08273 0.818192 10.183 2.91829 10.183 5.50013C10.1822 7.74604 6.62515 13.3169 5.49965 15.0235H5.4993Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.50048 2.04684C3.58229 2.04684 2.02148 3.60765 2.02148 5.52584C2.02148 7.44402 3.58229 9.00483 5.50048 9.00483C7.41866 9.00483 8.97947 7.44402 8.97947 5.52584C8.97947 3.60765 7.41866 2.04684 5.50048 2.04684ZM5.50048 8.18664C4.03352 8.18664 2.83971 6.99297 2.83971 5.52587C2.83971 4.05891 4.03338 2.86511 5.50048 2.86511C6.96743 2.86511 8.16124 4.05877 8.16124 5.52587C8.16124 6.99368 6.96743 8.18664 5.50048 8.18664Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPinNoFill);
export default __webpack_public_path__ + "static/media/locationPinNoFill.24337c8d255ef122e1b228b89f039cbb.svg";
export { ForwardRef as ReactComponent };